import { Grid } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";

import AttachmentForm from "../../../../forms/autorizacaoEspecial/AttachmentForm";
import FormFieldAttachmentBase, {
  FieldAttachment,
} from "../../../../forms/FormFieldAttachmentBase";
import ParticipationRequestForm from "../../../../forms/autorizacaoEspecial/ParticipationRequestForm";
import FormBase from "../../../../forms/FormBase";

interface IAutorizacaoEspecialAttachmentDataComponentProps {
  AutorizacaoEspecialAttachmentForm: AttachmentForm;
  ParticipationRequestForm: ParticipationRequestForm;
  onInputChange: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void;
  onDeleteFile: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void;
}

export default function AutorizacaoEspecialAttachmentDataComponent(
  props: IAutorizacaoEspecialAttachmentDataComponentProps
) {
  return (
    <div>
      <Grid container spacing={10}>
        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="Carta de Autorização assinada pelo Médico responsável pelo paciente "
                name="CartaAutorizacaoAssinada"
                limitedFiles={props.AutorizacaoEspecialAttachmentForm.CartaAutorizacaoAssinada.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.AutorizacaoEspecialAttachmentForm.CartaAutorizacaoAssinada.Values}
                error={props.AutorizacaoEspecialAttachmentForm.CartaAutorizacaoAssinada.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CartaAutorizacaoAssinada",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CartaAutorizacaoAssinada
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CartaAutorizacaoAssinada",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CartaAutorizacaoAssinada
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Carteira Profissional de Classe *"
                name="CarteiraProfissionalClasse"
                limitedFiles={props.AutorizacaoEspecialAttachmentForm.CarteiraProfissionalClasse.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.AutorizacaoEspecialAttachmentForm.CarteiraProfissionalClasse.Values}
                error={props.AutorizacaoEspecialAttachmentForm.CarteiraProfissionalClasse.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CarteiraProfissionalClasse",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CarteiraProfissionalClasse
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CarteiraProfissionalClasse",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CarteiraProfissionalClasse
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Certificado área de atuação ou instrumentação "
                name="CertificadoAtuacaoInstrumentacao"
                limitedFiles={props.AutorizacaoEspecialAttachmentForm.CertificadoAtuacaoInstrumentacao.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.AutorizacaoEspecialAttachmentForm.CertificadoAtuacaoInstrumentacao.Values}
                error={props.AutorizacaoEspecialAttachmentForm.CertificadoAtuacaoInstrumentacao.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertificadoAtuacaoInstrumentacao",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CertificadoAtuacaoInstrumentacao
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertificadoAtuacaoInstrumentacao",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CertificadoAtuacaoInstrumentacao
                  );
                }}
              />
            </Grid>
            
            <Grid item xs={12}>
              <Controls.Attachment
                label="Certidão de Ética Profissional (emitida pelo site do CREMESP)"
                name="CertidaoEticaProfissional"
                mandatory={(props.ParticipationRequestForm.RequestParticipate.Value === "MedicoPrincipal" || props.ParticipationRequestForm.RequestParticipate.Value === "MedicoAuxiliar")}
                infoMessage="Por favor inserir a Certidão de Ética apenas para profissionais médicos."
                limitedFiles={props.AutorizacaoEspecialAttachmentForm.CertidaoEticaProfissional.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.AutorizacaoEspecialAttachmentForm.CertidaoEticaProfissional.Values}
                error={props.AutorizacaoEspecialAttachmentForm.CertidaoEticaProfissional.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertidaoEticaProfissional",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CertidaoEticaProfissional
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertidaoEticaProfissional",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CertidaoEticaProfissional
                  );
                }}
              />
            </Grid>
          </Grid>

        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="CPF e RG "
                name="CPFeRG"
                limitedFiles={props.AutorizacaoEspecialAttachmentForm.CPFeRG.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.AutorizacaoEspecialAttachmentForm.CPFeRG.Values}
                error={props.AutorizacaoEspecialAttachmentForm.CPFeRG.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CPFeRG",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CPFeRG
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CPFeRG",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.CPFeRG
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Titulo de Especialista *"
                name="TituloEspecialista"
                limitedFiles={props.AutorizacaoEspecialAttachmentForm.TituloEspecialista.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.AutorizacaoEspecialAttachmentForm.TituloEspecialista.Values}
                error={props.AutorizacaoEspecialAttachmentForm.TituloEspecialista.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "TituloEspecialista",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.TituloEspecialista
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "TituloEspecialista",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.TituloEspecialista
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Relatório Médico"
                name="RelatorioMedico"
                mandatory={props.ParticipationRequestForm.RequestParticipate.Value === "MedicoPrincipal"}
                infoMessage="Por favor inserir o relatório referente aos procedimentos que serão realizados e dos materiais utilizados."
                limitedFiles={props.AutorizacaoEspecialAttachmentForm.RelatorioMedico.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.AutorizacaoEspecialAttachmentForm.RelatorioMedico.Values}
                error={props.AutorizacaoEspecialAttachmentForm.RelatorioMedico.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "RelatorioMedico",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.RelatorioMedico
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "RelatorioMedico",
                    props.AutorizacaoEspecialAttachmentForm,
                    fieldAttachment,
                    props.AutorizacaoEspecialAttachmentForm.RelatorioMedico
                  );
                }}
              />
            </Grid>


          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
